export default "__VITE_ASSET__BmdQ2cih__"